import { useSeo } from "@/lib/store";
import { EnquiryForm } from "@/components/EnquiryForm";

export default function UploadDesign() {
  useSeo("Upload Your Own Design", "Upload your artwork (PNG, JPG, WEBP, PDF) and get it printed on premium streetwear. Personal, bulk, wholesale and business merchandise orders.");
  return (
    <div className="max-w-[1500px] mx-auto px-4 sm:px-8 py-14" data-testid="upload-design-page">
      <p className="eyebrow">Your art · our craft</p>
      <h1 className="font-display text-5xl sm:text-7xl lg:text-8xl leading-[0.86] mt-4">UPLOAD YOUR<br /><span className="stroke-text">OWN</span> DESIGN</h1>
      <ol className="grid sm:grid-cols-3 gap-px bg-white/10 my-14">
        {[["01", "Upload artwork", "Multiple files, up to 15MB each."], ["02", "Tell us the fit", "Garment, colour, placement & sizes."], ["03", "Get your quote", "We reply on WhatsApp within 24 hours."]].map(([n, t, d]) => (
          <li key={n} className="bg-[#080808] p-6"><span className="font-display text-4xl text-neon">{n}</span><p className="font-semibold mt-2">{t}</p><p className="text-sm text-grey">{d}</p></li>
        ))}
      </ol>
      <EnquiryForm variant="upload" />
    </div>
  );
}
